export type UserRole = "seller" | "buyer" | "influencer";

export interface DropshipProduct {
  id: number;
  name: string;
  description: string;
  price: number;
  commission: number; // percentage
  stock: number;
  category: string;
  image: string;
  seller: string;
  sellerCountry: string;
  sellerFlag: string;
  sold: number;
}

export interface DropshipOrder {
  id: string;
  product: string;
  productImage: string;
  buyer: string;
  qty: number;
  total: number;
  status: "Pending" | "Processing" | "Shipped" | "Delivered";
  date: string;
  influencer: string;
  commission: number;
}

export interface InfluencerStat {
  id: number;
  name: string;
  platform: string;
  platform_icon: string;
  followers: string;
  flag: string;
  country: string;
  image: string;
  verified: boolean;
  productsSold: number;
  totalRevenue: number;
  commissionEarned: number;
  commissionRate: number;
  topProduct: string;
  recentSales: { product: string; qty: number; date: string; commission: number }[];
}

export const dropshipProducts: DropshipProduct[] = [
  {
    id: 1,
    name: "Wireless Earbuds Pro X200",
    description: "Premium TWS earbuds with active noise cancellation, 30hr battery life, IPX5 waterproof. Perfect for fitness and daily use. Comes with charging case and 3 ear tip sizes.",
    price: 29.99,
    commission: 15,
    stock: 4820,
    category: "Electronics",
    image: "https://public.readdy.ai/ai/img_res/974d7681f1bc9bd15842bdd98ca03739.jpg",
    seller: "Guangzhou Audio Electronics",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 12480,
  },
  {
    id: 2,
    name: "Vitamin C Brightening Serum 30ml",
    description: "20% Vitamin C + Hyaluronic Acid formula. Reduces dark spots, boosts collagen, and gives radiant glow in 2 weeks. Dermatologist tested, suitable for all skin types.",
    price: 18.5,
    commission: 20,
    stock: 9200,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20skincare%20bottle%2030ml%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20wellness%20premium&width=400&height=300&seq=ds2&orientation=landscape",
    seller: "Guangzhou Cosmetics OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 28340,
  },
  {
    id: 3,
    name: "LED RGB Strip Light 10m",
    description: "5050 SMD RGB LED strip with app control, music sync, and 16 million colors. Easy peel-and-stick installation. Perfect for room decoration, gaming setups, and parties.",
    price: 14.99,
    commission: 18,
    stock: 15600,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=LED%20strip%20light%20RGB%20colorful%20glowing%20room%20decoration%20on%20clean%20dark%20background%20professional%20product%20photography%20lighting%20electronics%20decoration%20premium&width=400&height=300&seq=ds3&orientation=landscape",
    seller: "Shenzhen LED World",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 34120,
  },
  {
    id: 4,
    name: "Bamboo Cutting Board Set 3pcs",
    description: "Eco-friendly bamboo cutting boards in 3 sizes. Naturally antibacterial, knife-friendly surface. Includes juice groove and hanging hole. Dishwasher safe.",
    price: 22.0,
    commission: 12,
    stock: 6800,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=bamboo%20cutting%20board%20set%203%20pieces%20kitchen%20eco%20friendly%20on%20clean%20white%20background%20professional%20product%20photography%20natural%20wood%20premium&width=400&height=300&seq=ds4&orientation=landscape",
    seller: "Anji Bamboo Products",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 8920,
  },
  {
    id: 5,
    name: "Collagen Face Cream 50ml",
    description: "Marine collagen + retinol anti-aging cream. Reduces wrinkles, firms skin, and deeply moisturizes. Fragrance-free, paraben-free. Results visible in 4 weeks.",
    price: 24.99,
    commission: 22,
    stock: 7400,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=collagen%20face%20cream%2050ml%20jar%20skincare%20anti%20aging%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=400&height=300&seq=ds5&orientation=landscape",
    seller: "Guangzhou Beauty OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 19650,
  },
  {
    id: 6,
    name: "Portable Mini Projector 1080P",
    description: "Full HD mini projector with built-in speaker, WiFi screen mirroring, and 120-inch projection. 5000 lumens brightness. Compatible with iOS, Android, HDMI, USB.",
    price: 89.99,
    commission: 10,
    stock: 2100,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=portable%20mini%20projector%201080P%20home%20cinema%20on%20clean%20white%20background%20professional%20product%20photography%20electronics%20entertainment%20premium&width=400&height=300&seq=ds6&orientation=landscape",
    seller: "Shenzhen Precision Tech Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 5430,
  },
  {
    id: 7,
    name: "Stainless Steel Insulated Water Bottle 750ml",
    description: "Double-wall vacuum insulated bottle keeps drinks cold 24hrs or hot 12hrs. BPA-free, leak-proof lid, wide mouth for easy cleaning. Available in 8 colors.",
    price: 19.99,
    commission: 14,
    stock: 11200,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20water%20bottle%20750ml%20clean%20white%20background%20professional%20product%20photography%20hydration%20fitness%20lifestyle%20premium&width=400&height=300&seq=ds7&orientation=landscape",
    seller: "Zhejiang Drinkware Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 22100,
  },
  {
    id: 8,
    name: "Yoga Mat Non-Slip TPE 6mm",
    description: "Eco-friendly TPE yoga mat with alignment lines, non-slip texture on both sides. 6mm thick for joint support. Includes carry strap. 183cm x 61cm.",
    price: 27.5,
    commission: 16,
    stock: 8400,
    category: "Sports & Fitness",
    image: "https://readdy.ai/api/search-image?query=yoga%20mat%20non%20slip%20TPE%20purple%20rolled%20up%20on%20clean%20white%20background%20professional%20product%20photography%20fitness%20wellness%20exercise%20premium&width=400&height=300&seq=ds8&orientation=landscape",
    seller: "Guangzhou Fitness Gear",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 15680,
  },
  {
    id: 9,
    name: "Retinol Anti-Wrinkle Eye Cream 20ml",
    description: "Concentrated retinol + peptide eye cream. Reduces crow's feet, dark circles, and puffiness in 3 weeks. Fragrance-free, ophthalmologist tested. Suitable for sensitive skin.",
    price: 21.99,
    commission: 22,
    stock: 6300,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=retinol%20eye%20cream%2020ml%20tube%20skincare%20anti%20aging%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=400&height=300&seq=ds9&orientation=landscape",
    seller: "Guangzhou Beauty OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 18920,
  },
  {
    id: 10,
    name: "Smart Watch Fitness Tracker IP68",
    description: "1.7-inch AMOLED display smartwatch with heart rate, SpO2, sleep tracking, 100+ sport modes. IP68 waterproof, 7-day battery. Compatible with iOS & Android.",
    price: 49.99,
    commission: 12,
    stock: 5800,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=smart%20watch%20fitness%20tracker%20AMOLED%20display%20on%20clean%20white%20background%20professional%20product%20photography%20wearable%20technology%20health%20premium&width=400&height=300&seq=ds10&orientation=landscape",
    seller: "Shenzhen Wearable Tech",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 31450,
  },
  {
    id: 11,
    name: "Aromatherapy Essential Oil Diffuser 500ml",
    description: "Ultrasonic cool mist diffuser with 7-color LED mood light, auto shut-off, and whisper-quiet operation. Covers 400 sq ft. Includes 4 essential oil samples.",
    price: 32.0,
    commission: 18,
    stock: 7100,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=aromatherapy%20essential%20oil%20diffuser%20500ml%20white%20mist%20on%20clean%20white%20background%20professional%20product%20photography%20home%20wellness%20relaxation%20premium&width=400&height=300&seq=ds11&orientation=landscape",
    seller: "Anji Bamboo Products",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 9870,
  },
  {
    id: 12,
    name: "Resistance Bands Set 5-Pack",
    description: "5 resistance levels (10-50 lbs) latex-free exercise bands. Includes door anchor, ankle straps, handles, and carry bag. Perfect for home gym, physical therapy, and travel.",
    price: 16.99,
    commission: 20,
    stock: 14500,
    category: "Sports & Fitness",
    image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%205%20pack%20colorful%20exercise%20fitness%20on%20clean%20white%20background%20professional%20product%20photography%20gym%20workout%20premium&width=400&height=300&seq=ds12&orientation=landscape",
    seller: "Guangzhou Fitness Gear",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 41200,
  },
  {
    id: 13,
    name: "Portable Blender USB Rechargeable 380ml",
    description: "6-blade stainless steel portable blender. USB-C rechargeable, 25,000 RPM motor. Makes smoothies in 30 seconds. BPA-free, leak-proof, dishwasher safe.",
    price: 24.99,
    commission: 17,
    stock: 9600,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=portable%20blender%20USB%20rechargeable%20380ml%20smoothie%20maker%20on%20clean%20white%20background%20professional%20product%20photography%20kitchen%20appliance%20premium&width=400&height=300&seq=ds13&orientation=landscape",
    seller: "Foshan Kitchenware Factory",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 27340,
  },
  {
    id: 14,
    name: "Niacinamide 10% + Zinc Serum 30ml",
    description: "Minimizes pores, controls oil, and brightens skin tone. 10% niacinamide + 1% zinc formula. Lightweight, non-greasy texture. Suitable for oily and combination skin.",
    price: 15.99,
    commission: 20,
    stock: 12800,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=niacinamide%20zinc%20serum%2030ml%20dropper%20bottle%20skincare%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=400&height=300&seq=ds14&orientation=landscape",
    seller: "Guangzhou Cosmetics OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 52300,
  },
  {
    id: 15,
    name: "Wireless Charging Pad 15W Fast Charge",
    description: "Qi-certified 15W fast wireless charger compatible with iPhone 15/14/13, Samsung Galaxy S24/S23, AirPods. Slim 7mm design with LED indicator and anti-slip surface.",
    price: 18.5,
    commission: 13,
    stock: 8900,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=wireless%20charging%20pad%2015W%20fast%20charge%20slim%20on%20clean%20white%20background%20professional%20product%20photography%20electronics%20accessories%20premium&width=400&height=300&seq=ds15&orientation=landscape",
    seller: "Shenzhen Precision Tech Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 38700,
  },
  {
    id: 16,
    name: "Linen Throw Pillow Covers 4-Pack 45x45cm",
    description: "Premium linen blend pillow covers with invisible zipper. Soft, breathable, and machine washable. Set of 4 in coordinating neutral tones. Fits standard 18x18 inch inserts.",
    price: 23.99,
    commission: 15,
    stock: 10200,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=linen%20throw%20pillow%20covers%204%20pack%20neutral%20tones%20on%20clean%20white%20background%20professional%20product%20photography%20home%20decor%20interior%20premium&width=400&height=300&seq=ds16&orientation=landscape",
    seller: "Nantong Textile Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 14560,
  },
  {
    id: 17,
    name: "Adjustable Dumbbell Set 2x10kg",
    description: "Space-saving adjustable dumbbells with quick-lock dial system. Replaces 6 pairs of weights. Non-slip handle, durable ABS shell. Ideal for home gym workouts.",
    price: 79.99,
    commission: 10,
    stock: 3200,
    category: "Sports & Fitness",
    image: "https://readdy.ai/api/search-image?query=adjustable%20dumbbell%20set%202x10kg%20home%20gym%20on%20clean%20white%20background%20professional%20product%20photography%20fitness%20equipment%20premium&width=400&height=300&seq=ds17&orientation=landscape",
    seller: "Guangzhou Fitness Gear",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 7840,
  },
  {
    id: 18,
    name: "Hyaluronic Acid Moisturizer SPF30 50ml",
    description: "Lightweight daily moisturizer with 3 types of hyaluronic acid + SPF30 UVA/UVB protection. Non-greasy, non-comedogenic. Plumps skin and prevents sun damage.",
    price: 19.99,
    commission: 21,
    stock: 9100,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20moisturizer%20SPF30%2050ml%20tube%20skincare%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=400&height=300&seq=ds18&orientation=landscape",
    seller: "Guangzhou Beauty OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 24600,
  },
  {
    id: 19,
    name: "Noise Cancelling Headphones Over-Ear",
    description: "40dB active noise cancellation, 40-hour battery, foldable design. Hi-Res Audio certified with 40mm drivers. Includes 3.5mm cable and travel case. Bluetooth 5.3.",
    price: 59.99,
    commission: 11,
    stock: 4100,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=noise%20cancelling%20headphones%20over%20ear%20black%20on%20clean%20white%20background%20professional%20product%20photography%20audio%20electronics%20premium&width=400&height=300&seq=ds19&orientation=landscape",
    seller: "Guangzhou Audio Electronics",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 11230,
  },
  {
    id: 20,
    name: "Macrame Wall Hanging Boho Decor 60cm",
    description: "Handcrafted cotton macrame wall art with natural wood dowel. Bohemian style, 60cm wide x 80cm long. Adds texture and warmth to any room. Ready to hang.",
    price: 28.0,
    commission: 19,
    stock: 5600,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=macrame%20wall%20hanging%20boho%20decor%20cotton%20natural%20on%20clean%20white%20background%20professional%20product%20photography%20home%20decor%20handcraft%20premium&width=400&height=300&seq=ds20&orientation=landscape",
    seller: "Yiwu Craft Exports",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 6780,
  },
  {
    id: 21,
    name: "Jump Rope Speed Cable Adjustable",
    description: "Professional speed jump rope with ball-bearing handles and adjustable steel cable. Suitable for CrossFit, boxing, and cardio. Includes 2 extra cables and carry bag.",
    price: 12.99,
    commission: 18,
    stock: 18700,
    category: "Sports & Fitness",
    image: "https://readdy.ai/api/search-image?query=jump%20rope%20speed%20cable%20adjustable%20fitness%20on%20clean%20white%20background%20professional%20product%20photography%20sports%20exercise%20premium&width=400&height=300&seq=ds21&orientation=landscape",
    seller: "Guangzhou Fitness Gear",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 33400,
  },
  {
    id: 22,
    name: "Beard Growth Serum 30ml Men Grooming",
    description: "Biotin + castor oil beard growth serum. Stimulates follicles, reduces patchiness, and softens beard. Results in 4-6 weeks. Suitable for all beard types.",
    price: 17.99,
    commission: 22,
    stock: 7800,
    category: "Health & Beauty",
    image: "https://readdy.ai/api/search-image?query=beard%20growth%20serum%2030ml%20men%20grooming%20bottle%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=400&height=300&seq=ds22&orientation=landscape",
    seller: "Guangzhou Cosmetics OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 16900,
  },
  {
    id: 23,
    name: "Portable Power Bank 20000mAh PD65W",
    description: "20000mAh power bank with 65W USB-C PD fast charging. Charges laptops, phones, and tablets. Dual USB-A + USB-C output. LED display, airline-approved.",
    price: 42.99,
    commission: 12,
    stock: 6200,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=portable%20power%20bank%2020000mAh%20PD65W%20on%20clean%20white%20background%20professional%20product%20photography%20electronics%20accessories%20premium&width=400&height=300&seq=ds23&orientation=landscape",
    seller: "Shenzhen Precision Tech Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 19800,
  },
  {
    id: 24,
    name: "Ceramic Non-Stick Frying Pan 28cm",
    description: "PFOA-free ceramic coating frying pan with ergonomic stay-cool handle. Even heat distribution, oven-safe to 450F. Compatible with all stovetops including induction.",
    price: 34.99,
    commission: 14,
    stock: 8300,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=ceramic%20non%20stick%20frying%20pan%2028cm%20kitchen%20cookware%20on%20clean%20white%20background%20professional%20product%20photography%20cooking%20premium&width=400&height=300&seq=ds24&orientation=landscape",
    seller: "Foshan Kitchenware Factory",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 12450,
  },
  {
    id: 25,
    name: "Foam Roller Deep Tissue Massage 33cm",
    description: "High-density EVA foam roller with grid texture for deep tissue massage and myofascial release. 33cm length, supports up to 300 lbs. Ideal for post-workout recovery.",
    price: 22.5,
    commission: 16,
    stock: 9900,
    category: "Sports & Fitness",
    image: "https://readdy.ai/api/search-image?query=foam%20roller%20deep%20tissue%20massage%2033cm%20fitness%20recovery%20on%20clean%20white%20background%20professional%20product%20photography%20sports%20premium&width=400&height=300&seq=ds25&orientation=landscape",
    seller: "Guangzhou Fitness Gear",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 21700,
  },
  {
    id: 26,
    name: "Silk Pillowcase Queen Size 2-Pack",
    description: "100% 22 momme mulberry silk pillowcase. Reduces hair breakage and skin creases. Hypoallergenic, temperature-regulating. Hidden zipper closure. Machine washable.",
    price: 38.0,
    commission: 20,
    stock: 5400,
    category: "Home & Garden",
    image: "https://readdy.ai/api/search-image?query=silk%20pillowcase%20queen%20size%20luxury%20bedding%20on%20clean%20white%20background%20professional%20product%20photography%20home%20decor%20sleep%20premium&width=400&height=300&seq=ds26&orientation=landscape",
    seller: "Suzhou Silk Factory",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 8920,
  },
  // ── Apparel ──────────────────────────────────────────────────────────────────
  {
    id: 27,
    name: "Men's Slim Fit Dress Shirt 100% Cotton",
    description: "Premium 100% cotton slim-fit dress shirt. Wrinkle-resistant, breathable fabric. Available in 12 colors and sizes S-3XL. Perfect for office, formal events, and casual wear.",
    price: 16.99,
    commission: 18,
    stock: 22000,
    category: "Apparel",
    image: "https://readdy.ai/api/search-image?query=mens%20slim%20fit%20dress%20shirt%20white%20cotton%20folded%20neatly%20on%20clean%20white%20background%20professional%20product%20photography%20fashion%20apparel%20premium%20quality&width=400&height=300&seq=ap1&orientation=landscape",
    seller: "Guangzhou Garment Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 48200,
  },
  {
    id: 28,
    name: "Women's Casual Linen Blazer",
    description: "Lightweight linen-blend blazer with notched lapel and two front pockets. Relaxed fit, unlined for breathability. Available in beige, white, and black. Sizes XS-XL.",
    price: 28.5,
    commission: 20,
    stock: 14500,
    category: "Apparel",
    image: "https://readdy.ai/api/search-image?query=womens%20casual%20linen%20blazer%20beige%20elegant%20fashion%20on%20clean%20white%20background%20professional%20product%20photography%20clothing%20apparel%20premium&width=400&height=300&seq=ap2&orientation=landscape",
    seller: "Hangzhou Fashion OEM",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 31600,
  },
  {
    id: 29,
    name: "Kids Organic Cotton T-Shirt 3-Pack",
    description: "GOTS-certified organic cotton tees for kids ages 2-12. Soft, hypoallergenic, pre-shrunk. Set of 3 in assorted colors. Machine washable, durable stitching.",
    price: 19.99,
    commission: 16,
    stock: 18700,
    category: "Apparel",
    image: "https://readdy.ai/api/search-image?query=kids%20organic%20cotton%20t-shirt%203%20pack%20colorful%20children%20clothing%20on%20clean%20white%20background%20professional%20product%20photography%20apparel%20premium&width=400&height=300&seq=ap3&orientation=landscape",
    seller: "Nantong Textile Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 27400,
  },
  {
    id: 30,
    name: "Unisex Streetwear Hoodie 380gsm",
    description: "Heavy 380gsm fleece hoodie with kangaroo pocket, ribbed cuffs, and adjustable drawstring. Oversized fit. Available in 8 colors. Sizes S-3XL. OEM/ODM welcome.",
    price: 24.99,
    commission: 17,
    stock: 16200,
    category: "Apparel",
    image: "https://readdy.ai/api/search-image?query=unisex%20streetwear%20hoodie%20heavy%20fleece%20oversized%20on%20clean%20white%20background%20professional%20product%20photography%20fashion%20apparel%20premium%20quality&width=400&height=300&seq=ap4&orientation=landscape",
    seller: "Guangzhou Garment Co.",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 52100,
  },
  // ── Machinery ────────────────────────────────────────────────────────────────
  {
    id: 31,
    name: "Mini CNC Router 3018 Pro Desktop",
    description: "3-axis desktop CNC router for wood, acrylic, PCB engraving. 300x180x45mm work area, 10,000 RPM spindle, GRBL control. Includes offline controller and 10 engraving bits.",
    price: 189.99,
    commission: 8,
    stock: 1800,
    category: "Machinery",
    image: "https://readdy.ai/api/search-image?query=mini%20CNC%20router%203018%20desktop%20engraving%20machine%20on%20clean%20white%20background%20professional%20product%20photography%20industrial%20machinery%20precision%20tool%20premium&width=400&height=300&seq=mc1&orientation=landscape",
    seller: "Shenzhen CNC Machinery",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 4320,
  },
  {
    id: 32,
    name: "Industrial Sewing Machine Lockstitch 550W",
    description: "Heavy-duty industrial lockstitch sewing machine. 550W servo motor, 5,500 SPM, automatic thread trimmer. Suitable for denim, leather, and heavy fabrics. CE certified.",
    price: 349.00,
    commission: 7,
    stock: 920,
    category: "Machinery",
    image: "https://readdy.ai/api/search-image?query=industrial%20sewing%20machine%20lockstitch%20heavy%20duty%20on%20clean%20white%20background%20professional%20product%20photography%20garment%20factory%20machinery%20premium&width=400&height=300&seq=mc2&orientation=landscape",
    seller: "Zhejiang Sewing Machinery",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 1870,
  },
  {
    id: 33,
    name: "Hydraulic Bottle Jack 20 Ton",
    description: "20-ton hydraulic bottle jack with safety valve and chrome-plated ram. Lifting range 240-470mm. Heavy-duty steel construction. CE/GS certified. For automotive and industrial use.",
    price: 68.50,
    commission: 10,
    stock: 3400,
    category: "Machinery",
    image: "https://readdy.ai/api/search-image?query=hydraulic%20bottle%20jack%2020%20ton%20industrial%20tool%20on%20clean%20white%20background%20professional%20product%20photography%20automotive%20machinery%20heavy%20duty%20premium&width=400&height=300&seq=mc3&orientation=landscape",
    seller: "Yongkang Tool Factory",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 6780,
  },
  // ── Auto Parts ───────────────────────────────────────────────────────────────
  {
    id: 34,
    name: "LED Headlight Bulbs H7 6000K 2-Pack",
    description: "H7 LED headlight conversion kit. 6000K cool white, 12,000LM per pair. IP68 waterproof, 360 degree adjustable beam. Plug-and-play for most vehicles. 50,000hr lifespan.",
    price: 32.99,
    commission: 14,
    stock: 12400,
    category: "Auto Parts",
    image: "https://readdy.ai/api/search-image?query=LED%20headlight%20bulbs%20H7%206000K%20bright%20white%20automotive%20on%20clean%20white%20background%20professional%20product%20photography%20car%20parts%20accessories%20premium&width=400&height=300&seq=au1&orientation=landscape",
    seller: "Guangzhou Auto Lighting",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 38900,
  },
  {
    id: 35,
    name: "Universal Car Seat Cover Full Set",
    description: "9-piece universal car seat cover set. Breathable mesh and PU leather combo. Fits 95% of sedans and SUVs. Includes headrest covers, airbag-compatible. Easy installation.",
    price: 54.99,
    commission: 13,
    stock: 8700,
    category: "Auto Parts",
    image: "https://readdy.ai/api/search-image?query=universal%20car%20seat%20cover%20full%20set%20black%20leather%20interior%20on%20clean%20white%20background%20professional%20product%20photography%20automotive%20accessories%20premium&width=400&height=300&seq=au2&orientation=landscape",
    seller: "Guangzhou Auto Accessories",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 21300,
  },
  {
    id: 36,
    name: "OBD2 Bluetooth Car Diagnostic Scanner",
    description: "ELM327 OBD2 Bluetooth 5.0 scanner. Reads and clears fault codes, live data, freeze frame. Compatible with iOS and Android. Supports all OBD2 protocols. Compact design.",
    price: 22.99,
    commission: 15,
    stock: 9800,
    category: "Auto Parts",
    image: "https://readdy.ai/api/search-image?query=OBD2%20bluetooth%20car%20diagnostic%20scanner%20tool%20on%20clean%20white%20background%20professional%20product%20photography%20automotive%20electronics%20premium&width=400&height=300&seq=au3&orientation=landscape",
    seller: "Shenzhen Auto Tech",
    sellerCountry: "China",
    sellerFlag: "🇨🇳",
    sold: 44600,
  },
];

export const dropshipOrders: DropshipOrder[] = [
  { id: "#DS-8821", product: "Wireless Earbuds Pro X200", productImage: "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20TWS%20earphones%20white%20charging%20case%20on%20clean%20white%20background%20professional%20product%20photography%20audio%20electronics%20premium&width=80&height=80&seq=ord1&orientation=squarish", buyer: "Sarah Johnson", qty: 2, total: 59.98, status: "Delivered", date: "Apr 8, 2026", influencer: "Mia Chen", commission: 9.0 },
  { id: "#DS-8820", product: "Vitamin C Serum 30ml", productImage: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20skincare%20bottle%2030ml%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20wellness%20premium&width=80&height=80&seq=ord2&orientation=squarish", buyer: "Mike Torres", qty: 3, total: 55.5, status: "Shipped", date: "Apr 7, 2026", influencer: "Emma Larsson", commission: 11.1 },
  { id: "#DS-8819", product: "LED RGB Strip Light 10m", productImage: "https://readdy.ai/api/search-image?query=LED%20strip%20light%20RGB%20colorful%20glowing%20room%20decoration%20on%20clean%20dark%20background%20professional%20product%20photography%20lighting%20electronics%20decoration%20premium&width=80&height=80&seq=ord3&orientation=squarish", buyer: "David Kim", qty: 1, total: 14.99, status: "Processing", date: "Apr 7, 2026", influencer: "Alex Rivera", commission: 2.7 },
  { id: "#DS-8818", product: "Collagen Face Cream 50ml", productImage: "https://readdy.ai/api/search-image?query=collagen%20face%20cream%2050ml%20jar%20skincare%20anti%20aging%20on%20clean%20white%20background%20professional%20product%20photography%20beauty%20cosmetics%20premium&width=80&height=80&seq=ord4&orientation=squarish", buyer: "Priya Sharma", qty: 2, total: 49.98, status: "Delivered", date: "Apr 6, 2026", influencer: "Mia Chen", commission: 11.0 },
  { id: "#DS-8817", product: "Portable Mini Projector 1080P", productImage: "https://readdy.ai/api/search-image?query=portable%20mini%20projector%201080P%20home%20cinema%20on%20clean%20white%20background%20professional%20product%20photography%20electronics%20entertainment%20premium&width=80&height=80&seq=ord5&orientation=squarish", buyer: "Carlos Mendez", qty: 1, total: 89.99, status: "Pending", date: "Apr 6, 2026", influencer: "Raj Patel", commission: 9.0 },
];

export const influencerStats: InfluencerStat[] = [
  {
    id: 1,
    name: "Alex Rivera",
    platform: "YouTube",
    platform_icon: "ri-youtube-line",
    followers: "4.2M",
    flag: "🇺🇸",
    country: "USA",
    image: "https://readdy.ai/api/search-image?query=young%20male%20tech%20influencer%20content%20creator%20professional%20portrait%20clean%20studio%20background%20confident%20smile%20modern%20style&width=300&height=300&seq=star1&orientation=squarish",
    verified: true,
    productsSold: 3842,
    totalRevenue: 98420,
    commissionEarned: 14763,
    commissionRate: 15,
    topProduct: "Wireless Earbuds Pro X200",
    recentSales: [
      { product: "Wireless Earbuds Pro X200", qty: 120, date: "Apr 8", commission: 539.82 },
      { product: "Portable Mini Projector 1080P", qty: 45, date: "Apr 6", commission: 404.96 },
      { product: "LED RGB Strip Light 10m", qty: 200, date: "Apr 4", commission: 539.64 },
    ],
  },
  {
    id: 2,
    name: "Mia Chen",
    platform: "TikTok",
    platform_icon: "ri-tiktok-line",
    followers: "8.7M",
    flag: "🇨🇳",
    country: "China",
    image: "https://readdy.ai/api/search-image?query=young%20female%20fashion%20influencer%20content%20creator%20professional%20portrait%20clean%20studio%20background%20stylish%20modern%20look&width=300&height=300&seq=star2&orientation=squarish",
    verified: true,
    productsSold: 9210,
    totalRevenue: 187500,
    commissionEarned: 37500,
    commissionRate: 20,
    topProduct: "Vitamin C Brightening Serum 30ml",
    recentSales: [
      { product: "Vitamin C Brightening Serum 30ml", qty: 450, date: "Apr 8", commission: 1665.0 },
      { product: "Collagen Face Cream 50ml", qty: 320, date: "Apr 7", commission: 1759.3 },
      { product: "Wireless Earbuds Pro X200", qty: 180, date: "Apr 5", commission: 809.73 },
    ],
  },
  {
    id: 3,
    name: "James Okafor",
    platform: "Facebook",
    platform_icon: "ri-facebook-circle-line",
    followers: "2.1M",
    flag: "🇳🇬",
    country: "Nigeria",
    image: "https://readdy.ai/api/search-image?query=professional%20male%20business%20influencer%20content%20creator%20portrait%20clean%20studio%20background%20confident%20suit%20modern%20style&width=300&height=300&seq=star3&orientation=squarish",
    verified: true,
    productsSold: 2140,
    totalRevenue: 54200,
    commissionEarned: 8130,
    commissionRate: 15,
    topProduct: "Bamboo Cutting Board Set 3pcs",
    recentSales: [
      { product: "Bamboo Cutting Board Set 3pcs", qty: 95, date: "Apr 7", commission: 250.8 },
      { product: "LED RGB Strip Light 10m", qty: 110, date: "Apr 5", commission: 296.8 },
      { product: "Vitamin C Brightening Serum 30ml", qty: 75, date: "Apr 3", commission: 277.5 },
    ],
  },
  {
    id: 4,
    name: "Sofia Martinez",
    platform: "Twitter/X",
    platform_icon: "ri-twitter-x-line",
    followers: "1.5M",
    flag: "🇪🇸",
    country: "Spain",
    image: "https://readdy.ai/api/search-image?query=young%20female%20entrepreneur%20influencer%20content%20creator%20professional%20portrait%20clean%20studio%20background%20smart%20casual%20modern&width=300&height=300&seq=star4&orientation=squarish",
    verified: false,
    productsSold: 1280,
    totalRevenue: 31200,
    commissionEarned: 4680,
    commissionRate: 15,
    topProduct: "Collagen Face Cream 50ml",
    recentSales: [
      { product: "Collagen Face Cream 50ml", qty: 60, date: "Apr 8", commission: 329.87 },
      { product: "Vitamin C Brightening Serum 30ml", qty: 40, date: "Apr 6", commission: 148.0 },
      { product: "Bamboo Cutting Board Set 3pcs", qty: 55, date: "Apr 4", commission: 145.2 },
    ],
  },
  {
    id: 5,
    name: "Raj Patel",
    platform: "YouTube",
    platform_icon: "ri-youtube-line",
    followers: "3.8M",
    flag: "🇮🇳",
    country: "India",
    image: "https://readdy.ai/api/search-image?query=professional%20male%20manufacturing%20industry%20influencer%20content%20creator%20portrait%20clean%20studio%20background%20confident%20modern%20style&width=300&height=300&seq=star5&orientation=squarish",
    verified: true,
    productsSold: 4560,
    totalRevenue: 112400,
    commissionEarned: 16860,
    commissionRate: 15,
    topProduct: "Portable Mini Projector 1080P",
    recentSales: [
      { product: "Portable Mini Projector 1080P", qty: 85, date: "Apr 8", commission: 764.92 },
      { product: "Wireless Earbuds Pro X200", qty: 200, date: "Apr 6", commission: 899.7 },
      { product: "LED RGB Strip Light 10m", qty: 150, date: "Apr 4", commission: 404.73 },
    ],
  },
  {
    id: 6,
    name: "Emma Larsson",
    platform: "TikTok",
    platform_icon: "ri-tiktok-line",
    followers: "5.3M",
    flag: "🇸🇪",
    country: "Sweden",
    image: "https://readdy.ai/api/search-image?query=young%20female%20home%20decor%20lifestyle%20influencer%20content%20creator%20professional%20portrait%20clean%20studio%20background%20elegant%20modern&width=300&height=300&seq=star6&orientation=squarish",
    verified: true,
    productsSold: 6830,
    totalRevenue: 145600,
    commissionEarned: 29120,
    commissionRate: 20,
    topProduct: "Vitamin C Brightening Serum 30ml",
    recentSales: [
      { product: "Vitamin C Brightening Serum 30ml", qty: 380, date: "Apr 8", commission: 1406.0 },
      { product: "Collagen Face Cream 50ml", qty: 290, date: "Apr 7", commission: 1594.36 },
      { product: "Bamboo Cutting Board Set 3pcs", qty: 120, date: "Apr 5", commission: 316.8 },
    ],
  },
];
